import React, { useEffect } from "react";
import QRCode from "react-qr-code";
import Image from "react-bootstrap/Image";
import cert from "../../assets/truapproval_capture2.png";
import StyledTRUCert from "./truStyled";
import { getAssetURL, currencyFormatter,formatPhoneNumber } from "../../utils";
//capture is used to generate borrower certificate
//html2canvas does not allow cross-origin integration without proxy
//so capture asset must be hosted in the repo



const TRUCertificate = ({
  captureRef,
  loan,
//   handleCapture,
  handleCanvasDataURL,
  load
}) => {
  
const [ready, setReady]=load
  useEffect(() => {
    if (ready) {
      handleCanvasDataURL();
    }
  }, [ready, handleCanvasDataURL]);

  return (
    <StyledTRUCert className="capture">
      <Image className="cert-bg" src={getAssetURL("cert-bg.svg")} />
      <Image className="tassles" src={getAssetURL("tassles.svg")} />
      <div className="canvas-box" ref={captureRef}>
        {ready && (
          <>
            <div className="canvas-header">
              <p className="canvas-header-text">{loan?.loanNumber}</p>
              <p className="canvas-header-text">{loan?.borrowerHeaderLine}</p>
            </div>
            {/* <div className="canvas-congrats-text">
              We are pleased to inform you that you have been TRU Approved&reg;.
              We have thoroughly reviewed your finances and congratulate you on
              this noteworthy achievement. This is a big step ahead in your
              mortgage process.
            </div> */}
            <div className="canvas-body">
              <div className="canvas-body-text">
                {currencyFormatter(parseInt(loan?.purchasePrice))}
              </div>
              <div className="canvas-body-text">
                {currencyFormatter(parseInt(loan?.loanAmount))}
              </div>
              <div className="canvas-body-text">{loan?.productCodeDesc}</div>
              <div className="canvas-body-text">{`${loan?.ltv}% / ${loan?.cltv}%`}</div>
              <div className="canvas-body-text">
                {`${loan?.interestRate}%`}
                <strong>APR:</strong>
                {`${loan?.apr}%`}
              </div>
              <div className="canvas-body-text">
                {currencyFormatter(
                  parseInt(loan?.newFirstMortPi + loan?.newOtherMortPi)
                )}
                <strong>Taxes, Insurance and HOA *:</strong>
                {currencyFormatter(
                  parseInt(
                    loan?.newHoa +
                      loan?.newMi +
                      loan?.newTaxes +
                      loan?.newHazIns
                  )
                )}
              </div>
              <div className="canvas-body-text">
                {currencyFormatter(
                  parseInt(
                    loan?.newFirstMortPi +
                      loan?.newOtherMortPi +
                      loan?.newHoa +
                      loan?.newMi +
                      loan?.newTaxes +
                      loan?.newHazIns
                  )
                )}
              </div>
              {/* <div className="canvas-body-text">
                This loan is reviewed considering the property as SFR. If the
                property type is changed to PUD or Condo then monthly
                association dues will be included in the DTI. Final loan
                approval will be based on the revised DTI after including HOA
                dues. Condo property should meet the project eligibility
                criteria as per applicable agency/investor guidelines.
              </div> */}
              <div className="canvas-body-text">
                {loan?.truApprovalDateAsString}
              </div>
              <div className="canvas-body-text">{loan?.creditExpireDate}</div>
            </div>
            <div className="canvas-works-text">
              {currencyFormatter(
                parseInt(
                  loan?.newFirstMortPi +
                    loan?.newOtherMortPi +
                    loan?.newHoa +
                    loan?.newMi +
                    loan?.newTaxes +
                    loan?.newHazIns
                )
              )}
            </div>
            <div className="canvas-contact-card">
              <div className="canvas-contact-text">{loan?.interviewerName}</div>
              <div className="canvas-contact-text">
                D:{" "}
                <a href={`tel:+${loan?.interviewerPhone}`}>
                  {formatPhoneNumber(loan?.interviewerPhone)}
                </a>
              </div>
              <div className="canvas-contact-text">
                {loan?.interviewerEmail || "truapproval@swmc.com"}
              </div>
              <div className="canvas-contact-text">
                {loan?.interviewerCompAddress}
              </div>
              <div className="canvas-contact-text">
                {loan?.interviewerCompCityStateZip}
              </div>

              <div className="canvas-contact-text">{`Branch NMLS ${loan?.interviewerNmlsId}`}</div>
            </div>
            <div title="Track your Loan Progress!" className="qr-box">
              <div className="qr-code">
                <QRCode
                  value={`https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusPostLogin.jsf?loginType=borrower&email=${loan?.loanEmail}&action=loanStatusGraphDiv`}
                />
              </div>
              <p className="qr-text">
                Scan this code to track your Loan Progress!
              </p>
            </div>
          </>
        )}
        <Image
          onLoad={() => setReady(true)}
          className="canvas-cert"
          src={cert}
        />
      </div>
    </StyledTRUCert>
  );
};
export default TRUCertificate;
